import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import {doppeActionTypeHoppEvent} from './doppe-action-type-hopp-event';

export const doppeActionTypeHoppEventViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppEvent, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppEventWidget: (await import('./doppe-action-type-hopp-event-widget/doppe-action-type-hopp-event-widget')).DoppeActionTypeHoppEventWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppEventWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppEventWidget
                {...renderProps}
            />
        );
    },
}); 